import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteAudioStart } from "../../redux/audio/reducer";

import {
  selectIsDeletingAudio,
  selectIsCreatingAudio,
} from "../../redux/audio/selectors";

const useAudioUploader = () => {
  const dispatch = useDispatch();
  const isCreating = useSelector(selectIsCreatingAudio);
  const isDeleting = useSelector(selectIsDeletingAudio);
  // const createAudio = useCallback(
  //   (data) => {
  //     dispatch(createAudioStart(data));
  //   },
  //   [dispatch]
  // );

  const deleteAudio = useCallback(
    (data) => {
      dispatch(deleteAudioStart(data));
    },
    [dispatch]
  );

  return {
    audioCreating: isCreating,
    isDeleting,
    // createAudio,
    deleteAudio,
  };
};

export default useAudioUploader;
